import React from 'react';
import AboutImage from "../assests/HomeAbout.jpg";

const HomeAbout = () => {

  const pageHandler =()=>{
    window.location.href = "/about-us";
  }
  
  return (
    <section className="home-about-section">
      <div className="home-about-container">
        <div className="home-about-content">
          <h2 className="home-about-heading">About Us</h2>
          <p className="home-about-description">
            Welcome to Vortex Gym! We are committed to helping you achieve your fitness goals with our state-of-the-art equipment, expert trainers, and a wide range of fitness classes. Whether you’re looking to build muscle, lose weight, or improve your overall health, we have the resources and support you need to succeed.
          </p>
          <button className="home-about-button" onClick={pageHandler}>Learn More</button>
        </div>
        <div className="home-about-image-container">
          <img src={AboutImage} alt="About Us" className="home-about-image" />
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;